import { gql } from '@apollo/client';

const removeAgentServiceQuery = gql`
  mutation ($id: Int) {
    removeAgentService(id: $id)
  }
`;
export default removeAgentServiceQuery;
